export default __webpack_public_path__ + "logo_fleetcare.89a7954.svg";